<template>
  <div class="hidden-input">
    <input v-bind:id="field.name" type="hidden" v-model="field.value" v-bind:name="field.name"/>
  </div>
</template>

<script>
export default {
  name: 'TextInput',
  props: {
    field: {
      type: Object,
      default () {
        return {
          value: '',
          valid: false,
          dirty: false
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// HiddenInput.vue?176b69e0